import React from 'react';
import { PictoProps } from './index';

export const Message = (props: PictoProps) => (
  <svg
    width={props.width || '16'}
    height={props.height || '12'}
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0562 0H4.94375C2.4875 0 0.5 1.97421 0.5 4.41404V5.82951C0.5 8.17622 2.35625 10.1132 4.7 10.2436C4.55 10.765 4.34375 11.1748 4.1 11.51C3.875 11.808 3.85625 12.2178 4.04375 12.5344C4.2125 12.8324 4.5125 13 4.85 13H4.94375C6.3875 12.851 8.88125 12.3109 9.65 10.2436H11.0562C13.5125 10.2436 15.5 8.26934 15.5 5.82951V4.41404C15.5 1.97421 13.5125 0 11.0562 0ZM14.375 5.82951C14.375 7.65473 12.8938 9.12607 11.0562 9.12607H9.51875C9.10625 9.12607 8.75 9.38682 8.61875 9.77794C8.16875 11.1748 6.44375 11.659 5.225 11.8266C5.4875 11.3983 5.69375 10.8954 5.84375 10.2994C5.91875 10.0201 5.8625 9.72206 5.675 9.47994C5.4875 9.23782 5.225 9.10745 4.925 9.10745C3.10625 9.12607 1.625 7.65473 1.625 5.82951V4.41404C1.625 2.58883 3.10625 1.11748 4.94375 1.11748H11.0562C12.8938 1.11748 14.375 2.58883 14.375 4.41404V5.82951Z"
      fill={props.fill || 'white'}
    />
  </svg>
);
